import { gql } from '@apollo/client';

export const GET_PAYMENT_LINK_INTEGRATION = gql`
  query getPaymentLinkIntegrationFilteredList(
    $search: PaymentLinkIntegrationSearchInput = {}
    $limit: Int = 10
    $sortDirection: SortDirection = DESC
    $sortField: PaymentLinkIntegrationSortField = createdAt
  ) {
    getPaymentLinkIntegrationFilteredList(
      search: $search
      limit: $limit
      sortDirection: $sortDirection
      sortField: $sortField
    ) {
      id
      status
      platformServerId
      platformServerName
      platformUserId
      platformUsername
      platformMetadata
      connectedAt
      createdAt
      updatedAt
      paymentLinkId
      userId
      type
    }
  }
`;

export const CREATE_PAYMENT_LINK_INTEGRATION = gql`
  mutation createPaymentLinkIntegrationTier(
    $paymentLinkIntegrationId: ID
    $platformRoleId: String
    $membershipTierId: ID!
    $autoKickOnDowngrade: Boolean
  ) {
    createPaymentLinkIntegrationTier(
      paymentLinkIntegrationId: $paymentLinkIntegrationId
      platformRoleId: $platformRoleId
      membershipTierId: $membershipTierId
      autoKickOnDowngrade: $autoKickOnDowngrade
    ) {
      autoKickOnDowngrade
      createdAt
      membershipTierId
      paymentLinkId
      paymentLinkIntegrationId
      platformRoleId
      platformRoleMetadata
      platformRoleName
      updatedAt
      userId
    }
  }
`;

export const GET_PAYMENT_LINK_INTEGRATION_TIER = gql`
  query getPaymentLinkIntegrationTierFilteredList($search: PaymentLinkIntegrationTierSearchInput, $limit: Int) {
    getPaymentLinkIntegrationTierFilteredList(search: $search, limit: $limit) {
      id
      autoKickOnDowngrade
      createdAt
      membershipTierId
      paymentLinkId
      paymentLinkIntegrationId
      platformRoleId
      platformRoleMetadata
      platformRoleName
      updatedAt
      userId
    }
  }
`;

export const GET_INVITE_PLATFORM_SERVER = gql`
  query getInvitePlatformServer($paymentLinkId: ID!, $redirectURI: String!) {
    getInvitePlatformServer(paymentLinkId: $paymentLinkId, redirectURI: $redirectURI) {
      inviteURL
    }
  }
`;

export const GET_DISCORD_ROLES = gql`
  query getDiscordRoles($platformServerId: String!) {
    getDiscordRoles(platformServerId: $platformServerId) {
      guildId
      guildName
      roles {
        id
        name
        isAssignable
      }
    }
  }
`;

export const DISCONNECT_PAYMENT_LINK_INTEGRATION = gql`
  mutation disconnectPaymentLinkIntegration($paymentLinkIntegrationId: ID!) {
    disconnectPaymentLinkIntegration(paymentLinkIntegrationId: $paymentLinkIntegrationId) {
      success
      errorMessage
    }
  }
`;
